export default __webpack_public_path__ + "static/media/Logo.d9785992.png";